import React from 'react';

const AdminSettings = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Settings</h1>
      <p>Manage your application settings here</p>
    </div>
  );
};

export default AdminSettings;